import { render, staticRenderFns } from "./RealNameReport.vue?vue&type=template&id=073cea43&scoped=true"
import script from "./RealNameReport.vue?vue&type=script&lang=js"
export * from "./RealNameReport.vue?vue&type=script&lang=js"
import style0 from "./RealNameReport.vue?vue&type=style&index=0&id=073cea43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073cea43",
  null
  
)

export default component.exports